// src/AdMaxBanner.js
import React, { useEffect, useRef } from 'react';
import './App.css';
import postscribe from 'postscribe';

const AdMaxBanner = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      postscribe(ref.current, `
      <div class="ad-wrapper ad-300x60" style="width:100%;display:block;text-align:center;line-height:0;margin:0;padding:0;">
        <!-- admax -->
        <script src="https://adm.shinobi.jp/o/9b4377e440e75a8febb922538c171fdd"></script>
        <!-- admax -->
      </div>
      `);
    }
  }, []);
  return (
    <div
      ref={ref}
      style={{
        width: '100%',
        textAlign: 'center',
        margin: 0,
        padding: 0,
        // ? �e�ɂ� overflow:visible �𖾎��i�O�̂��߁j
        overflow: 'visible',
      }}
    />
  );
};

export default AdMaxBanner;
